/**
 * Helpers for text selection
 * @module lib/select_text
 */

/**
 * Select text in the given node
 * @param {HTMLElement} node
 */
export default function selectText(node) {
  if (document.body.createTextRange) {
    const range = document.body.createTextRange();
    range.moveToElementText(node);
    range.select();
  } else if (window.getSelection) {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(node);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/select_text.js